(() => {
  const MOBILE_MQ = '(max-width: 1099px)';

  const initPeek = (peek) => {
    if (peek.dataset.peekBound === 'true') return;
    peek.dataset.peekBound = 'true';

    const targetId = peek.dataset.productPeekTarget;
    const target = document.getElementById(targetId);
    const toggles = peek.querySelectorAll('[data-product-peek-toggle]');
    if (!target || !toggles.length) return;

    let dragStartY = null;
    let dragged = false;

    const isMobile = () => window.matchMedia(MOBILE_MQ).matches;
    const peekHeight = () => peek.offsetHeight || 120;

    const setPeekHeightVar = () => {
      document.documentElement.style.setProperty('--product-peek-h', `${peekHeight()}px`);
    };

    const syncHandoff = () => {
      if (!isMobile()) {
        peek.hidden = true;
        peek.classList.remove('is-handed-off');
        document.documentElement.style.setProperty('--product-peek-h', '0px');
        return;
      }

      peek.hidden = false;

      const targetTop = target.getBoundingClientRect().top;
      const dockLine = window.innerHeight - peekHeight();
      const handedOff = targetTop <= dockLine + 1;
      peek.classList.toggle('is-handed-off', handedOff);

      // Keep layout offsets stable while peek is visible; ease to 0 when faded out
      document.documentElement.style.setProperty(
        '--product-peek-h',
        handedOff ? '0px' : `${peekHeight()}px`
      );
    };

    const scrollToDetails = () => {
      if (!isMobile()) return;

      const absoluteTop = target.getBoundingClientRect().top + window.scrollY;
      // Bring the real card to the top of the viewport; peek hands off as it docks
      window.scrollTo({
        top: Math.max(0, absoluteTop - 8),
        behavior: 'smooth',
      });
    };

    toggles.forEach((toggle) => {
      toggle.addEventListener('click', (event) => {
        event.preventDefault();
        if (dragged) {
          dragged = false;
          return;
        }
        scrollToDetails();
      });
      toggle.addEventListener(
        'touchstart',
        (event) => {
          dragStartY = event.touches[0].clientY;
          dragged = false;
        },
        { passive: true }
      );
      toggle.addEventListener(
        'touchmove',
        (event) => {
          if (dragStartY == null) return;
          const delta = dragStartY - event.touches[0].clientY;
          if (Math.abs(delta) > 8) dragged = true;
          if (delta > 28) {
            dragStartY = null;
            scrollToDetails();
          }
        },
        { passive: true }
      );
      toggle.addEventListener('touchend', () => {
        dragStartY = null;
      });
    });

    const atcButton = peek.querySelector('[data-product-peek-atc]');
    if (atcButton) {
      atcButton.addEventListener('click', async (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (atcButton.getAttribute('aria-disabled') === 'true' || atcButton.disabled) return;

        const formId = atcButton.dataset.productForm;
        const form =
          (formId && document.getElementById(formId)) ||
          document.querySelector('form[data-type="add-to-cart-form"]');
        const variantInput = form && form.querySelector('[name="id"]');
        const variantId = (variantInput && variantInput.value) || atcButton.dataset.variantId;
        if (!variantId) return;

        const cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
        const spinner = atcButton.querySelector('.loading-overlay__spinner');
        atcButton.setAttribute('aria-disabled', 'true');
        atcButton.classList.add('loading');
        if (spinner) spinner.classList.remove('hidden');

        try {
          const config = fetchConfig('javascript');
          config.headers['X-Requested-With'] = 'XMLHttpRequest';
          delete config.headers['Content-Type'];
          const formData = new FormData();
          formData.append('id', variantId);
          formData.append('quantity', '1');
          if (cart && typeof cart.getSectionsToRender === 'function') {
            formData.append(
              'sections',
              cart.getSectionsToRender().map((section) => section.id).join(',')
            );
            formData.append('sections_url', window.location.pathname);
          }
          config.body = formData;
          const response = await fetch(
            (window.routes && window.routes.cart_add_url) || '/cart/add.js',
            config
          );
          const data = await response.json();
          if (data.status) return;
          if (cart && typeof cart.renderContents === 'function') {
            cart.classList.remove('is-empty');
            cart.renderContents(data);
          } else {
            window.location = (window.routes && window.routes.cart_url) || '/cart';
          }
        } catch (error) {
          console.error(error);
        } finally {
          atcButton.classList.remove('loading');
          atcButton.removeAttribute('aria-disabled');
          if (spinner) spinner.classList.add('hidden');
        }
      });
    }

    window.addEventListener('scroll', syncHandoff, { passive: true });
    window.addEventListener('resize', () => {
      setPeekHeightVar();
      syncHandoff();
    });
    setPeekHeightVar();
    syncHandoff();
  };

  const initAll = () => {
    document.querySelectorAll('[data-product-peek]').forEach(initPeek);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  document.addEventListener('shopify:section:load', initAll);
})();
